import { IApplicationState, TBoardId, TListId } from '../../../../../../../../../types/types';
import { getPushNotificationMoveToListIds } from '../../../../../../../../../store/model/selectors/getPushNotificationMoveToListIds';
import { createDeepEqualSelector } from '../../../../../../../helpers/memoizeHelper';
import { IList } from '../../../../../../../../../store/model/list/types';
import { ISelectOptionsArray } from 'kui';
import { getBoardListsByStatus } from 'app/store/model/selectors/getBoardListsByStatus';

type TgetListMoveToSelectOptions = (
    state: IApplicationState,
    boardId: TBoardId,
) => ISelectOptionsArray;

export const getListMoveToSelectOptionsSelector = (): TgetListMoveToSelectOptions => createDeepEqualSelector(
    getBoardListsByStatus,
    getPushNotificationMoveToListIds,
    (lists: IList[], moveToListIds: TListId[]) => {
        return lists.map(list => {
            return {
                active: moveToListIds.includes(list.id),
                value: list.id,
                text: list.name,
            };
        });
    }
)
